/**********************************************************************
// @@@ START COPYRIGHT @@@
//        AVI SOLAR ENERGY CONFIDENTIAL: NEED TO KNOW ONLY
//        Copyright 2018 - 2019
//        Avi Solar Energy Pvt Ltd.
//        Protected as an unpublished work.
//  The computer program listings, specifications and documentation
//  herein are the property of Avi Solar Energy Pvt Ltd., or a third party supplier
//  and shall not be reproduced, copied, disclosed, or used in whole or in part for
//  any reason without the prior express written permission of Avi Solar Energy Pvt Ltd.
// @@@ END COPYRIGHT @@@
// +++ Code modified on 2019/02/25
**********************************************************************/
import { Api } from '@/services/Api'

export default {
  getInverterReport(param) {
    return Api().post('/api/v1.0/report-inverter', param)
  },
  getScbReport(param) {
    return Api().post('/api/v1.0/report-scb', param)
  },
  getWsReport(param) {
    return Api().post('/api/v1.0/report-ws', param)
  },
  getMfmReport(param) {
    return Api().post('/api/v1.0/report-mfm', param)
  },
  getReport(param) {
    return Api().post('/api/v2/report', param)
  },
  getReportOpt(param, reportName) {
    return Api().request({
      url: `/api/v2/report/download/${param}`,
      method: 'GET',
      responseType: 'blob' // important
    }).then(response => {
      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', reportName + (new Date()).getTime() + '.csv.gz') // or any other extension
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    })
  },
  fetchReportCSV(param) {
    return Api().post('/api/v1.0/report/download', param)
  }
}
